import { metadata } from './metadata';
import { dimensions } from './dimensions';
import { getChartOptions } from './mapping';
import { visualOptions } from './visualOptions';
import { colorDomain } from './render';
import { defaultOptionsValues } from './defaultOptionsValues';

export const treemapchart = {
  metadata,
  dimensions,
  getChartOptions,
  visualOptions,
  colorDomain,
  defaultOptionsValues,
};
